export interface WadObserver {
  observeElement: (el: Element) => void
  startObserving: (el: Element) => void
  stopObserving: (el: Element) => void
}

export default defineNuxtPlugin(() => {
  let trackingObserver: IntersectionObserver | undefined
  let observer: IntersectionObserver | undefined

  const trackingObserverOptions: IntersectionObserverInit = { threshold: 0.4 }
  const observerOptions: IntersectionObserverInit = { threshold: 0.4 }

  const trackEntityView = (entries: IntersectionObserverEntry[], obs: IntersectionObserver) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        entry.target.dispatchEvent(new CustomEvent('wadIsIntersecting'))
        obs.unobserve(entry.target)
      }
    })
  }

  const fireObserverEvents = (entries: IntersectionObserverEntry[]) => {
    entries.forEach((entry) => {
      entry.target.dispatchEvent(
        new CustomEvent(entry.isIntersecting ? 'wadIsIntersecting' : 'wadIsNotIntersecting')
      )
    })
  }

  const initTrackingObserver = () => {
    trackingObserver = new IntersectionObserver(trackEntityView, trackingObserverOptions)
  }

  const initObserver = () => {
    observer = new IntersectionObserver(fireObserverEvents, observerOptions)
  }

  const $wadObserver: WadObserver = {
    observeElement: (el: Element) => {
      if (!trackingObserver) initTrackingObserver()
      trackingObserver?.observe(el)
    },
    startObserving: (el: Element) => {
      if (!observer) initObserver()
      observer?.observe(el)
    },
    stopObserving: (el: Element) => {
      observer?.unobserve(el)
    },
  }

  return { provide: { wadObserver: $wadObserver } }
})
